// Function to fetch the cart
async function fetchCart() {
  const response = await fetch("/cart.js", {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  });
  return response.json();
}

// Function to add a product to the cart
async function addProductToCart(productId, quantity = 1) {
  jQuery
    .post(window.Shopify.routes.root + "cart/add.js", {
      items: [
        {
          id: productId,
          quantity: 1,
        },
      ],
      sections: "cart-drawer,cart-bubble",
    })
    .then((state) => {
      const parsedState = JSON.parse(state);
      renderContents(parsedState);
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}

// Function to add a product to the cart
async function removeProductToCart(productId, quantity = 0) {
 
  jQuery
    .post(window.Shopify.routes.root + "cart/change.js", {
      id: productId, // The ID of the product variant in the cart
      quantity: quantity, // Quantity to update; set to 0 to remove the item
      sections: "cart-drawer,cart-bubble,main-cart", // Optional: for updating specific sections
    })
    .then((state) => {
      const parsedState = JSON.parse(state);
      renderContents(parsedState);
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}



function getSectionInnerHTML(html, selector = ".shopify-section") {
  return new DOMParser()
    .parseFromString(html, "text/html")
    .querySelector(selector).innerHTML;
}
function getSectionsToRender() {
  return [
    {
      id: "Cart",
      section: "main-cart",
      selector: ".thb-cart-form",
    },
    {
      id: "Cart-Drawer",
      section: "cart-drawer",
      selector: ".cart-drawer",
    },
    {
      id: "cart-drawer-toggle",
      section: "cart-bubble",
      selector: ".thb-item-count",
    },
  ];
}



function renderContents(parsedState) {
  getSectionsToRender().forEach((section) => {
    if (!document.getElementById(section.id)) {
      return;
    }
    const elementToReplace =
      document.getElementById(section.id).querySelector(section.selector) ||
      document.getElementById(section.id);
    elementToReplace.innerHTML = getSectionInnerHTML(
      parsedState.sections[section.section],
      section.selector
    );

    if (typeof CartDrawer !== "undefined") {
      new CartDrawer();
    }
    if (typeof Cart !== "undefined") {
      new Cart().renderContents(parsedState);
    }
  });
if (window.location.href.indexOf("/cart") === -1) {
  let product_drawer = document.getElementById("Product-Drawer");
  if (document.getElementById("Cart-Drawer")) {
    document.body.classList.add("open-cc");
    document.body.classList.add("open-cart");
    document.getElementById("Cart-Drawer").classList.add("active");
    dispatchCustomEvent("cart-drawer:open");
  }
}
}





// Polling function to listen for cart updates
let previousCartState = null;

async function checkCartUpdatesForRemoval() {
//Only run if spend more message is displaying in cart drawer, signifying expedited order value not met or if expedited in need of removal present, signifying expedited is in cart and 5000 threshold not met
  if (document.querySelector('#expeditedInNeedOfRemoval')){
    
      removeProductToCart(42434109898831);
    }

  }
  




document.addEventListener("line-item:change:end", function (evt) {

  setTimeout(checkCartUpdatesForRemoval(), 100);
     
});

document.addEventListener("cart:item-added", function (evt) {


    const linkElement = document.querySelector("a[title='Expedited Build']");
    const expeditedInNeedOfRemoval = document.querySelector("#expeditedInNeedOfRemoval");
    if (linkElement) {
        // Extract the href value
        const hrefValue = linkElement.getAttribute('href');
        
        // Use URLSearchParams to parse the query string
        const urlParams = new URLSearchParams(hrefValue.split('?')[1]);
        const variantId = urlParams.get('variant');

    } else {
      const element = document.querySelector('#expedited-build-product');
      const expeditedProduct = element?.getAttribute('data-expediteProduct');
      addProductToCart(expeditedProduct);
    }
  


});



  
